var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.el,{tag:"component",staticClass:"wrap-try"},[_vm._v(" "+_vm._s(_vm.$t(_vm.text))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }